import { useState, useEffect } from 'react';
import { getAllCourses, getFeaturedCourses, getReviews, getCourseById } from '../api';
import { Course, StudentReview } from '../types';

export const useCourses = () => {
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const items = await getAllCourses();
        setCourses(items);
      } catch (e) {
        setError('Failed to load courses');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return { courses, loading, error };
};

export const useFeaturedCourses = () => {
  const [featuredCourses, setFeaturedCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const items = await getFeaturedCourses();
        setFeaturedCourses(items);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return { featuredCourses, loading };
};

export const useReviews = () => {
  const [reviews, setReviews] = useState<StudentReview[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const items = await getReviews();
        setReviews(items);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return { reviews, loading };
};

export const useCourseDetail = (courseId: string) => {
  const [course, setCourse] = useState<Course | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const item = await getCourseById(courseId);
        setCourse(item || null);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [courseId]);

  return { course, loading };
};